import { defineMessages } from 'react-intl'

/**
 * High-frequency cross-vertical CTAs and recovery links — `docs/product-taxonomy.md` §15.
 * Prefer these over retyping the same `defaultMessage` in offer, order, and cancellation flows.
 */
const commonMessages = defineMessages({
  browseAllHotelOffers: {
    id: 'rY7YWkfRXds97SZoD7yj',
    defaultMessage: 'Browse all hotel offers',
    description: 'Link or button to browse all hotel offers when the current offer is sold out or unavailable',
  },
  browseAllCruiseOffers: {
    id: 'fmoni6H9-d0M4c-6Xcuy',
    defaultMessage: 'Browse all cruise offers',
    description: 'Link to the cruise search or list when a cruise offer is unavailable or has ended',
  },
  browseAllExperiences: {
    id: 'w54uY2Z1A3WYA6q2GZrq',
    defaultMessage: 'Browse all experiences',
    description: 'Link to experience search when the selected experience is sold out or has no tickets',
  },
  browseYourFavouriteEscapes: {
    defaultMessage: 'Browse your favourite escapes',
    id: 'D_NWPBTcYv84ZbD7SZ3a',
    description: 'Marketing or recovery link to personalised or wishlist-based offer discovery surfaces',
  },
  viewBundleOffer: {
    defaultMessage: 'View bundle offer',
    id: 'KUDq4NZH1t22KubLWkaq',
    description: 'Call-to-action to open a bundle or package offer detail from summary cards or email',
  },
  viewVoucher: {
    id: '4DN24eqpJaloIsiXwotg',
    defaultMessage: 'View voucher',
    description: 'Link to view a single experience or service voucher for an order or inclusion',
  },
  viewVouchers: {
    id: 'lBxzx9OIxRxuEghkdrce',
    defaultMessage: 'View vouchers',
    description: 'Link to a list of vouchers and redemption details for a booking or experience order',
  },
  changeFlight: {
    id: 'UF8AvylAPag2IbfiKdoW',
    defaultMessage: 'Change flight',
    description: 'CTA to change a booked flight segment from order view, self-serve, or support flows',
  },
  addFlights: {
    id: 'aINrX7JfIZ78xp-sCui6',
    defaultMessage: 'Add flights',
    description: 'CTA to add flights to a hotel, tour, or package from offer page toggles and summaries',
  },
  returnToMyEscapes: {
    id: 'miLg2wrMGuITe0x00irA',
    defaultMessage: 'Return to My Escapes',
    description: 'Post-success or post-cancellation link taking the customer back to their bookings list',
  },
  sendToAgent: {
    id: 'P8qHRO8gkwya796q-SlG',
    defaultMessage: 'Send to agent',
    description:
      'CTA to share a quote, itinerary, or trip plan with a travel agent (Trip Planner, AgentHub)',
  },
})

export default commonMessages
